(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fct-footer-review-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    const instances = new WeakMap();
    const enhance = (section) => {
      section.querySelectorAll('.fct-review-badge-ready').forEach((block) => {
        if (block.querySelector('.jdgm-all-reviews-text')) return;
        block.querySelector(':scope > .fct-footer-review-badge')?.remove();
        block.classList.remove('fct-review-badge-ready');
      });
      section.querySelectorAll('.jdgm-all-reviews-text').forEach((widget) => {
        const source = widget.querySelector('.jdgm-all-reviews-text__text');
        const originalLink = source?.querySelector('a[href]') || widget.querySelector('a[href]');
        const block = widget.closest('.fct-footer-apps__block');
        if (!source || !originalLink || !block) return;
        const rating = Number(source.dataset.score);
        const count = Number(source.dataset.numberOfReviews);
        const sentence = source.textContent.trim();
        const compact = sentence.match(/([\d.,]+)\s*\/\s*5\b.*?\b([\d.,\s]+\s+reviews?)\.?\s*$/i);
        const href = originalLink.getAttribute('href');
        const locale = source.dataset.locale || document.documentElement.lang || undefined;
        const formatNumber = (number, digits) => {
          try { return number.toLocaleString(locale, { maximumFractionDigits: digits }); }
          catch { return number.toLocaleString(undefined, { maximumFractionDigits: digits }); }
        };
        let badge = block.querySelector(':scope > .fct-footer-review-badge');
        if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isFinite(count) || count <= 0 || !sentence || !href || /^javascript:/i.test(href)) {
          badge?.remove();
          block.classList.remove('fct-review-badge-ready');
          widget.removeAttribute('aria-hidden');
          widget.querySelectorAll('[data-fct-review-tabindex]').forEach((link) => {
            const original = link.dataset.fctReviewTabindex;
            if (original === '') link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', original);
            delete link.dataset.fctReviewTabindex;
          });
          return;
        }
        if (!badge) {
          badge = document.createElement('a');
          badge.className = 'fct-footer-review-badge';
          const stars = document.createElement('span');
          stars.className = 'fct-footer-review-badge__stars';
          stars.setAttribute('aria-hidden', 'true');
          stars.textContent = '★★★★★';
          const fill = document.createElement('span');
          fill.className = 'fct-footer-review-badge__stars-fill';
          fill.textContent = '★★★★★';
          stars.append(fill);
          const copy = document.createElement('span');
          copy.className = 'fct-footer-review-badge__copy';
          copy.setAttribute('aria-hidden', 'true');
          const score = document.createElement('span');
          score.className = 'fct-footer-review-badge__score';
          const reviewCount = document.createElement('span');
          reviewCount.className = 'fct-footer-review-badge__count';
          copy.append(score, reviewCount);
          badge.append(stars, copy);
          block.append(badge);
        }
        badge.href = href;
        badge.style.setProperty('--fct-review-fill', `${rating / 5 * 100}%`);
        const target = originalLink.getAttribute('target');
        if (target) badge.setAttribute('target', target);
        else badge.removeAttribute('target');
        badge.setAttribute('rel', target === '_blank' ? 'noopener noreferrer' : originalLink.getAttribute('rel') || '');
        badge.querySelector('.fct-footer-review-badge__score').textContent = compact ? `${formatNumber(rating, 1)}/5` : sentence;
        badge.querySelector('.fct-footer-review-badge__count').textContent = compact ? `${formatNumber(count, 0)} ${compact[2].trim().match(/reviews?$/i)[0]}` : '';
        badge.setAttribute('aria-label', compact ? `${badge.querySelector('.fct-footer-review-badge__score').textContent} ${badge.querySelector('.fct-footer-review-badge__count').textContent}` : sentence);
        widget.setAttribute('aria-hidden', 'true');
        widget.querySelectorAll('a').forEach((link) => {
          if (!link.hasAttribute('data-fct-review-tabindex')) link.dataset.fctReviewTabindex = link.getAttribute('tabindex') || '';
          link.setAttribute('tabindex', '-1');
        });
        block.classList.add('fct-review-badge-ready');
      });
    };
    const initialize = (scope = document) => {
      scope.querySelectorAll('.fct-footer-apps, .fct-compact-footer').forEach((section) => {
        if (instances.has(section)) return;
        const observer = new MutationObserver(() => {
          observer.disconnect();
          enhance(section);
          observe();
        });
        const observe = () => observer.observe(section, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-score', 'data-number-of-reviews', 'href', 'target']
        });
        enhance(section);
        observe();
        instances.set(section, observer);
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.fct-footer-apps, .fct-compact-footer').forEach((section) => {
        instances.get(section)?.disconnect();
        instances.delete(section);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fct-product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', event => {
  const detail = event.target;
  if (!detail.matches?.('.fct-product-details') || !detail.open) return;
  const group = detail.closest('[data-fct-product-accordions]');
  group?.querySelectorAll('.fct-product-details[open]').forEach(other => {
    if (other !== detail) other.open = false;
  });
}, true);
  } catch(e) { console.error(e); }
})();

})();
